import { Provider } from 'react-redux';
import { applyMiddleware, compose, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createRequestMiddleware } from 'redux-requests';
import thunk from 'redux-thunk';
import { config } from 'src/constants';

import reducer from './reducers';

const INITIAL_STATE = {
  domain: {
    notifications: [],
  },
  requests: {},
};

function configureStore(middlewares = [], initialState = INITIAL_STATE) {
  const composeEnhancer = config.isDevEnv ? composeWithDevTools : compose;
  const store = createStore(
    reducer,
    initialState,
    composeEnhancer(
      applyMiddleware(thunk, createRequestMiddleware(), ...middlewares)
    )
  );

  return {
    store,
    Provider,
  };
}

export default configureStore;
